// Kiểu dữ liệu khách hàng (hợp đồng crm) + hằng số hiển thị. Nhãn giai đoạn / mức độ / loại chăm sóc lấy từ
// @cathouse/domain (qua shared/lib) — không tự đặt lại nhãn.
import type { crm, deal } from '@cathouse/contracts';
import { STAGE } from '@/shared/lib';
import type { Tone } from '@/shared/ui';

export type CustomerRow = crm.CustomerRow;
export type CustomerList = crm.CustomerList;
export type CustomerFacets = crm.CustomerFacets;
export type CustomerDetail = crm.CustomerDetail;
export type CustomerPermissions = crm.CustomerPermissions;
export type CustomerActivity = crm.CustomerActivityView;
export type CustomerActivityPage = crm.CustomerActivityPage;
export type UnitMatch = crm.UnitMatchView;
export type CustomerTask = crm.TaskRow;
export type CustomerDeal = deal.CustomerDealItem;
export type PhoneDuplicate = crm.PhoneDuplicateResult;
export type CustomerSearchHit = crm.CustomerSearchHit;
export type CustomerOption = crm.CustomerOption;
export type AssignableStaff = crm.AssignableStaff;
export type CustomerImportView = crm.CustomerImportView;
export type CustomerImportResult = crm.CustomerImportResult;
export type CustomerExportView = crm.CustomerExportView;
export type CreateCustomerResult = crm.CreateCustomerResult;
export type Stage = crm.Stage;
export type Rating = crm.Rating;
export type CustomerFilter = crm.CustomerFilter;
export type ActivityType = crm.ActivityType;

/** Cột sắp xếp ở server (GET /crm/customers?sort=[-]key). */
export type CustomerSortKey = 'lastActivityAt' | 'name' | 'stage';
export type SortDir = 'asc' | 'desc';
export const CUSTOMER_SORT_KEYS: readonly CustomerSortKey[] = ['lastActivityAt', 'name', 'stage'];

/** Bộ lọc danh sách (khoá truy vấn qk.customers.list). */
export interface CustomerListFilters {
  filter: CustomerFilter;
  stage?: Stage;
  source?: string;
  ownerId?: string;
  q?: string;
  sort: CustomerSortKey;
  dir: SortDir;
}
/** Bộ lọc của số đếm (server không theo chip đang chọn — như prototype). */
export type CustomerFacetFilters = Pick<CustomerListFilters, 'stage' | 'source' | 'ownerId' | 'q'>;

/** Dòng hiển thị tối đa của danh sách (prototype: 300 dòng đầu + gợi ý thu hẹp bộ lọc). */
export const LIST_LIMIT = 300;

export const RATING_TONE: Record<Rating, Tone> = { hot: 'bad', warm: 'warn', cold: 'info' };
export const stageTone = (s: Stage): Tone => STAGE[s]?.tone ?? '';
export const stageLabel = (s: Stage) => STAGE[s]?.label ?? s;
/** Giai đoạn do giao dịch điều khiển (không đổi tay — crm C6). */
export const DEAL_STAGES: readonly Stage[] = ['deposited', 'contracted'];

/** Số hiển thị: số đầy đủ (chủ khách / đã "Hiện số") có khoảng trắng; số che giữ nguyên. Không bao giờ bỏ che ở FE. */
export function phoneLabel(display: string | null | undefined) {
  const p = display ?? '';
  if (!p || p.includes('*') || p.length !== 10) return p;
  return `${p.slice(0, 4)} ${p.slice(4, 7)} ${p.slice(7)}`;
}
